import html2canvas from 'html2canvas';

/**
 * Do a screenshot from the view
 *
 * @param {Object} params
 * @example {
 *    selector<String>: '.app',
 *    width<NUmber>: 100 (pixels from width),
 *    height<Number>: 100 (pixels from height),
 *    x: -10 (position coordinate x),
 *    y: -20 (position coordinate y),
 *    optionsHtml2canvas<Object>: { (options dependencia html2canvas)
 *      imageTimeout: 30000
 *    }
 * }
 * @return {CanvasHTML}
 */
async function screenshotCanvas({
  selector = 'body',
  width = null,
  height = null,
  x = 0,
  y = 0,
  optionsHtml2canvas = {},
}) {
  const options = {
    width,
    height,
    x,
    y,
    ...optionsHtml2canvas,
  };

  const elementHTML = document.querySelector(selector);

  return await html2canvas(elementHTML, options);
}

/**
 * Return a promise with the value of blob from canvas
 *
 * @param {Object} params
 * @example {
 *    selector<String>: '.app',
 *    width<NUmber>: 100 (pixels from width),
 *    height<Number>: 100 (pixels from height),
 *    x: -10 (position coordinate x),
 *    y: -20 (position coordinate y),
 *    optionsHtml2canvas<Object>: { (options dependencia html2canvas)
 *      imageTimeout: 30000
 *    }
 *    format<String>: 'image/png' (format to image),
 * }
 * @return {Promise}
 */
function screenhotToBlob({
  selector = 'body',
  width = null,
  height = null,
  x = 0,
  y = 0,
  format = 'image/png',
  optionsHtml2canvas = {},
}) {
  return new Promise(async (resolve) => {
    const canvas = await screenshotCanvas({
      selector, width, height, x, y, optionsHtml2canvas,
    });

    canvas.toBlob((blob) => {
      const reader = new FileReader();
      reader.addEventListener('loadend', () => {
        resolve(reader.result);
      });
      reader.readAsArrayBuffer(blob);
    }, format);
  });
}

/**
 * Return a promise with the value of blob from canvas
 *
 * @param {Object} params
 * @example {
 *    selector<String>: '.app',
 *    width<NUmber>: 100 (pixels from width),
 *    height<Number>: 100 (pixels from height),
 *    x: -10 (position coordinate x),
 *    y: -20 (position coordinate y),
 *    optionsHtml2canvas<Object>: { (options dependencia html2canvas)
 *      imageTimeout: 30000
 *    }
 *    format<String>: 'image/png' (format to image),
 * }
 * @return {String}
 */
async function screenhotToURL({
  selector = 'body',
  width = null,
  height = null,
  x = 0,
  y = 0,
  format = 'image/png',
  optionsHtml2canvas = {},
}) {
  const canvas = await screenshotCanvas({selector, width, height, x, y, optionsHtml2canvas});
  return canvas.toDataURL(format);
}

export {
  screenshotCanvas,
  screenhotToBlob,
  screenhotToURL,
};
